export const internmentMap: GenericObject = {
	id: "id",
	cid_principal: "icdPrimary",
	cid_secundario: "icdSecondary",
	data_hora_admissao: "dateTimeAdmission",
	data_hora_saida: "dateTimeDeparture",
	tipo_alta: "dischargeType",
};
